<template>
  <div>
    <div class="bg-transparent">
      <!--begin::Header-->
      <div class="d-flex justify-content-between pb-3 align-items-center">
        <slot name="title">
        <div>
          <h2 class="mb-2 fs-heading-two">
              <span>{{ defaultTitle }}</span>
            </h2>
          </div>
        </slot>
        <div class="d-flex">
          <slot name="right-btn"></slot>
          <slot name="add_button">
            <a @click="addRecord" class="btn btn-outline btn-outline-primary">
              <add-button-icon/>
              {{ $t("add_new") }}
            </a>
          </slot>
        </div>
      </div>
      <!--end::Header-->
      <!--<div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">
          <slot name="add_button">
            <button type="button" @click="addRecord" class="btn btn-primary">{{$t("add_new")}}</button>
          </slot>
        </h6>
      </div>-->
      <slot name="search"></slot>
      <div class="">
        <slot name="table">
          <div class="table-responsive mt-4 border border-light rounded-3 shadow-sm border-top-0">
            <table class="table">
              <thead>
              <tr>
                <slot name="thead">
                  <!--<tr class="fw-bolder text-muted">-->
                  <template v-for="(th, index) in header_">
                    <th v-if="th.key" @click="sort(th)" class="cursor-pointer text-body bg-light">
                      {{ th.name }}
                      <span v-if="order_.col==th.key">
                      <i class="text-primary fa"
                         :class="{'fa-sort-up':  order_.dir=='asc', 'fa-sort-down':  order_.dir=='desc',}"/>
                    </span>
                    <span v-else><i class="fa fa-sort"></i></span>
                    </th>
                    <th v-else class="text-body bg-light">{{ th.name }}</th>
                  </template>
                  <!--</tr>-->
                </slot>
              </tr>
              </thead>
              <slot name="tbody-notag">
                <tbody>
                <slot name="tr">
                  <tr v-for="(record, index) in data.records" :key="record.id" :class="{'bg-danger': record.is_deleted}">
                    <slot name="tbody" :record="record" :index="index"/>
                  </tr>
                </slot>
                </tbody>
              </slot>
            </table>
          </div>
        </slot>
      </div>
      <div class="card-footer">
        <slot name="footer">
          <table-pagination
              v-if="data.paginated"
              @handler="pageNavigate"
              :pagenum="data.page"
              :pagination="data.pager"
          ></table-pagination>
        </slot>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
      default: {
        title: '',
        header: [],
        records: [],
        ordered: true,
        order: {},
        paginated: true,
        page: 1,
        pager: {},
        createLabel: ''
      }
    },
  },
  data() {
    return {
      // header_: [],
      // title: '',
      // records: [],
      // header: [],
      sorted: 'desc',
    }
  },
  watch: {
    'data.records': function (val) {
      // this.records = val
    }
  },
  computed: {
    header_(){
      if(this.data.header){
        const headers = this.data.header.map(ele => {
          if (typeof ele === 'string') return {name: ele, sort: this.sorted};
          if (typeof ele === 'object' && ele.key) return {...ele, sort: this.sorted};
          if (typeof ele === 'object') return {...ele, sort: this.sorted};
          throw TypeError('type must be string or valid object: {title,key}')
        })
        return headers
      }
      return []
    },
    order_(){
      return _.get(this.data, 'order', {})
    },
    //custom title
    defaultTitle() {
      return this.data.title || this.$route?.meta?.title;
    },
    createLabel() {
      return this.data.createLabel || this.data.title || this.$route?.meta?.title;
    },
  },
  mounted() {
    // this.title = this.data.title
    // this.header = this.data.header
    if (this.data.sorted) {
      this.sorted = this.data.sorted
    }
  },
  methods: {
    pageNavigate(page) {
      // if parent component has the method, call it. or emit event
      if(this.$attrs.nav){
        console.info('THELPER_HAS_ATTR_NAV')
        return this.$attrs.nav(page)
      }
      if(this.$parent.nav){
        console.info('THELPER_PARENT_HAS_ATTR_NAV')
        this.$parent.nav(page)
      }
      this.$emit("nav", page);
    },
    addRecord() {
      if(this.$attrs.add){
        return this.$attrs.add()
      }
      this.$parent.add ? this.$parent.add() : this.$emit("add");
    },
    sort(item) {
      //flip sort
      item.sort = item.sort === 'asc' ? 'desc' : 'asc';
      if(this.$attrs.sort){
        return this.$attrs.sort(item)
      }
      this.$parent.sort ? this.$parent.sort(item) : this.$emit('sort', item);
    },
  },
};
</script>
